import { render, staticRenderFns } from "./BookingSuccessMobile.vue?vue&type=template&id=0bacc3f6&scoped=true"
import script from "./BookingSuccessMobile.vue?vue&type=script&lang=js"
export * from "./BookingSuccessMobile.vue?vue&type=script&lang=js"
import style0 from "./BookingSuccessMobile.vue?vue&type=style&index=0&id=0bacc3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bacc3f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VDivider,VIcon,VImg,VTooltip})
